<template>
    <div
        @click="handleClick"
        @mouseenter="mouseEnter"
        @mouseleave="mouseLeave"
        @mousemove="mouseMove"
        ref="parent"
        class="pop-menu-parent"
    >
        <div class="pop-menu" v-if="popover" :style="{ left, top }">
            <div class="rect"></div>
            <div
                class="popover-item"
                :content="'Filtreye Ekle'"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    zIndex: 9999999999,
                }"
                v-if="filterAdd"
                @click="addFilter"
            >
                <component is="search-add" color="white" />
            </div>
            <div
                class="popover-item"
                :content="'Filtreden Çıkar'"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    zIndex: 9999999999,
                }"
                v-if="filterRemove"
                @click="removeFilter"
            >
                <component is="search-remove" color="white" />
            </div>
            <div
                class="popover-item"
                :content="'Kopyala'"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                    zIndex: 9999999999,
                }"
                v-if="copy"
                @click="copyText"
            >
                <div class="material-icons">content_copy</div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "HoverMenuCell",
    props: {
        filterAdd: {
            type: Boolean,
            default: true,
        },
        filterRemove: {
            type: Boolean,
            default: false,
        },
        copy: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        popover: false,
        x: 0,
        y: 0,
        left: 0,
        top: 0,
        hidePopoverTimerId: null,
    }),
    methods: {
        addFilter() {
            console.log("addFilter click");
            this.$emit("filterAdded");
        },
        removeFilter() {
            console.log("removeFilter click");
            this.$emit("filterRemoved");
        },
        copyText() {
            const textToCopy = this.$slots.default[0].text.trim();
            navigator.clipboard.writeText(textToCopy).then(() => {
                console.log("Text copied to clipboard:", textToCopy);
                this.$emit("copyText");
            }).catch(err => {
                console.error("Failed to copy text: ", err);
            });
        },
        calculatePopoverPosition() {
            const el = this.$refs.parent;
            const { x, y, width, height } = el.getBoundingClientRect();
            // console.log("el.getBoundingClientRect()", el.getBoundingClientRect());

            this.left = x + width / 2 + "px";
            this.top = y - height * 2 + "px";
        },
        handleClick(e) {
            e.stopPropagation();
        },
        mouseEnter(e) {
            this.popover = true;
            this.x = e.clientX;
            this.y = e.clientY;
            this.calculatePopoverPosition();
            if (this.hidePopoverTimerId) {
                clearTimeout(this.hidePopoverTimerId);
            }
        },
        mouseLeave() {
            this.hidePopoverTimerId = setTimeout(() => {
                this.popover = false;
            }, 200);
        },
        mouseMove(e) {
            this.x = e.clientX;
            this.y = e.clientY;
            this.calculatePopoverPosition();
            if (this.hidePopoverTimerId) {
                clearTimeout(this.hidePopoverTimerId);
            }
        },
    },
});
</script>

<style lang="scss">
.pop-menu-parent {
    position: relative;
}

.pop-menu {
    position: fixed;
    background-color: #242424;
    padding: 10px;
    border-radius: 4px;
    user-select: none;
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .rect {
        width: 10px;
        height: 10px;
        background-color: #242424;
        position: absolute;
        left: 2px;
        bottom: -2.5px;
        transform: rotate(45deg);
        z-index: 99999999;
    }

    .popover-item {
        display: flex;
        align-items: center;
        cursor: pointer;

        .material-icons {
            color: white;
            font-size: 18px;
        }
    }
}
</style>
